import gql from "graphql-tag";

export const interviewScriptFragment = gql`
  {
    id
  }
`;
